import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { doFetchAiConversationSuggestions } from 'ducks/ai/operations'
import { selectCurrentTicketId } from 'selectors/tickets/current/selectCurrentTicketId'
import { selectAccountGlobalId } from 'ducks/accounts/selectors/selectAccountId'
import {
  selectSuggestionsIsLoading,
  selectSuggestionsIsLoaded,
} from 'ducks/ai/selectors/suggestions'
import { Loader } from 'shared/ui'
import { useFeature } from 'ducks/billing/hooks'
import { FEATURE_AI_MAX_CLASSIFICATIONS } from 'ducks/billing/featureTypes'

import sparkles from 'assets/icons/emoji/sparkles.png'
import CollapsableCard from 'components/CollapsableCard'
import SortableVisibleControlsWithTitle from '../../../SortableVisibleControlsWithTitle'
import Content from './Content'

import { styles } from './styles'

export default function Attachments({ doHideCard }) {
  const dispatch = useDispatch()
  const ticketId = useSelector(selectCurrentTicketId)
  const accountId = useSelector(selectAccountGlobalId)

  const isLoading = useSelector(state =>
    selectSuggestionsIsLoading(state, ticketId)
  )
  const isLoaded = useSelector(state =>
    selectSuggestionsIsLoaded(state, ticketId)
  )

  const { canUseFeature: canUseClassifications } = useFeature(
    FEATURE_AI_MAX_CLASSIFICATIONS
  )

  useEffect(
    () => {
      if (!isLoaded && !isLoading) {
        dispatch(doFetchAiConversationSuggestions({ ticketId }))
      }
    },
    [dispatch, isLoaded, isLoading, ticketId]
  )

  if (ticketId === 'new') {
    return null
  }

  return (
    <CollapsableCard
      persistenceKey={'customWidget.ai'}
      title={
        <SortableVisibleControlsWithTitle
          css={styles.controls}
          title={
            <div className="grui flex items-center relative">
              AI Overview <img src={sparkles} css={styles.icon} alt="" />
              {canUseClassifications && (
                <span css={styles.earlyAccess}>early access</span>
              )}
            </div>
          }
          onHide={doHideCard}
        />
      }
      css={styles.card}
    >
      {isLoading && <Loader className="grui my-7" />}
      {isLoaded && (
        <Content
          ticketId={ticketId}
          accountId={accountId}
          canUseClassifications={canUseClassifications}
        />
      )}
    </CollapsableCard>
  )
}
